var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4348 32H8V16.3182H13.4348V32ZM10.7185 14.2273C9.21522 14.2273 8 13.0553 8 11.6126C8 10.1699 9.21739 9 10.7185 9C12.2163 9 13.4348 10.172 13.4348 11.6126C13.4348 13.0553 12.2163 14.2273 10.7185 14.2273ZM33 32H27.775V24.3682C27.775 22.548 27.7391 20.2073 25.0587 20.2073C22.338 20.2073 21.9196 22.1895 21.9196 24.2365V32H16.6957V16.3067H21.7109V18.4509H21.7815C22.4793 17.2173 24.1848 15.9167 26.7283 15.9167C32.0217 15.9167 33 19.167 33 23.3928V32Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.b11955fcb4da9634c6e6b94559e36b17.svg";
export { ForwardRef as ReactComponent };